import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  adminPage: {
    padding: theme.spacing(6, 10),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(3),
    }
  },
  adminPageTitle: {
    fontSize: 25,
    fontWeight: 700,
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      fontSize: 20,
      display: 'flex',
      alignItems: 'center',
    },
  },
  goBack: {
    position: "absolute",
    right: "calc(100% + 22px)",
    top: "50%",
    transform: "translate(0, -50%)",
    cursor: 'pointer',
    [theme.breakpoints.down("sm")]: {
      position: "static",
      transform: "translate(0, 0)",
      marginRight: theme.spacing(1.5),
    },
  },
  formGroup: {
    marginBottom: theme.spacing(4),
  },
  formGroupLabel: {
    fontSize: 20,
    fontWeight: 500,
    marginBottom: theme.spacing(2),
  },
  unlockUserCard: {
    backgroundColor: "rgb(255, 208, 208)",
    borderColor: 'rgb(229, 8, 8)',
    border: '1px solid',
    padding: theme.spacing(2.5),
  },
  unlockPageCard: {
    backgroundColor: "rgb(246, 246, 246)",
    padding: theme.spacing(2.5),
  },
  iconTextCard: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row'
  },
  unlockButtonCard: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  unlockUserLabel: {
    fontSize: 18,
    fontWeight: 500,
    color: 'rgb(229, 8, 8)',
    marginBottom: theme.spacing(2),
    textAlign: 'center',
  },
  lockUserLabel: {
    fontSize: 18,
    fontWeight: 500,
    color: 'rgb(0, 0, 0)',
    marginBottom: theme.spacing(2),
    textAlign: 'center',
  },
  lockIcon: {
    marginTop: '-22px',
    marginRight: '5px',
  },
  unlockButtonXl: {
    borderRadius: `${theme.spacing(3)}px !important`,
    padding: theme.spacing(1, 3),
    fontSize: "1.275rem",
    height: "auto",
    backgroundColor: "rgb(0,0,0)",
    color: 'rgb(255,255,255)',
    fontSize: 20,
    fontWeight: 200,
  },
  formInfoLabel: {
    marginTop: '33px',
    marginLeft: '30px',
    fontSize: 14,
    fontWeight: 500,
    marginBottom: theme.spacing(0),
  },
  formGroupUsersLabel: {
    marginTop: '20px',
    marginLeft: '30px',
    fontSize: 14,
    fontWeight: 500,
    marginBottom: theme.spacing(0),
  },
  formGroupAdminInfoLabel: {
    marginTop: '10px',
    marginLeft: '30px',
    fontSize: 14,
    color: 'rgb(152, 152, 152)',
    fontWeight: 300,
    marginBottom: theme.spacing(0),
  },
  deleteGroupOutlinedButton: {
    marginTop: '25px',
    backgroundColor: "transparent",
  },
  adminOtherInfoCard: {
    backgroundColor: "rgb(246, 246, 246)",
    padding: theme.spacing(2.5),
  },
  spacer: {
    width: "100%",
    margin: theme.spacing(1, 0),
  },
  adminInput: {
    margin: theme.spacing(2.5, 0),
    "& .MuiInputLabel-root": {
      transform: "translate(0, 1.5px) scale(1)",
      fontSize: 15,
      fontWeight: 400,
      color: "#000",
    },
    "& .MuiInputBase-root": {
      height: 50,
    },
    "& .MuiInputBase-input": {
      padding: `14px 10px`,
    },
  },
  adminInputLabel: {
    fontSize: 15,
    fontWeight: 400,
    color: "#000",
  },
  userRoleCheckboxWrapper: {
    display: "flex",
    margin: theme.spacing(3, -1.5),
    overflow: 'auto'
  },
  userRoleCheckboxInner: {
    border: "1px solid rgb(233, 233, 233)",
    padding: theme.spacing(3, 2, 3, 5),
    margin: theme.spacing(0, 1.5),
    width: 200,
    position: "relative",
    "& .MuiCheckbox-root:not(.Mui-checked)": {
      color: "rgb(233, 233, 233)",
    },
  },
  userRoleCheckboxInnerSelected: {
    borderColor: theme.palette.primary.main,
  },
  userRoleCheckboxInnerDisabled: {
    opacity: 0.5,
  },
  userRoleCheckbox: {
    position: "absolute",
    right: "100%",
    top: "calc(50% - 2px)",
    transform: "translate(0, -50%)",
  },
  userRoleCheckboxTitle: {
    fontSize: 12,
    fontWeight: 500,
    color: "rgb(13, 13, 13)",
    marginBottom: theme.spacing(1),
    position: "relative",
  },
  userRoleCheckboxDesc: {
    color: "rgb(152, 152, 152)",
    fontSize: 12,
  },
  primaryButtonXl: {
    borderRadius: `${theme.spacing(3)}px !important`,
    padding: theme.spacing(1, 5),
    fontSize: "1.275rem",
    height: "auto",
  },
  adminPageCard: {
    backgroundColor: "rgb(246, 246, 246)",
    padding: theme.spacing(2.5),
  },
  secondaryOutlinedButton: {
    backgroundColor: "transparent",
  },
  adminPageCardLabel: {
    fontWeight: 500,
    width: "100%",
  },
  adminPageCardLink: {
    fontWeight: 500,
    color: "rgba(23, 132, 255, 1)",
    marginBottom: theme.spacing(4),
    display: "inline-block",
    backgroundColor: "transparent",
    [theme.breakpoints.down("sm")]: {
      textAlign: "left",
      height: "auto",
    },
  },
  adminPageCardValue: {
    color: "rgba(152, 152, 152, 1)",
    width: "100%",
  },
  adminPageCardListitem: {
    flexWrap: "wrap",
  },
  adminPageHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  adminPageInfo: {
    backgroundColor: "rgba(255, 244, 208, 1)",
    borderRadius: 50,
    padding: theme.spacing(1.5, 4),
    display: "flex",
    alignItems: "center",
    fontSize: 15,
    fontWeight: 500,
  },
  adminPageInfoIcon: {
    marginRight: theme.spacing(4),
  },
  customRadioWrapper: {
    display: "flex",
    alignItems: "center",
  },
  labelWithLoader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  circularProgressSmall: {
    width: `${theme.typography.pxToRem(20)} !important`,
    height: `${theme.typography.pxToRem(20)} !important`,
  },
  userSearchResultWrapper: {
    width: '100%',
    minHeight: "70vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  menuItemRadio: {
    width: '14px',
    height: '14px',
    borderRadius: '14px',
    border: '1px solid rgb(151,151,151)',
    margin: theme.spacing(1)
  },
  menuItemRadioSelected: {
    border: '1px solid rgb(255,211,40)',
    margin: theme.spacing(1)
  },
  licenseGroup: {
    marginBottom: theme.spacing(3),
    display: 'flex',
    justifyContent: 'space-between'
  },
  licenceDetailsCard: {
    marginBottom: theme.spacing(3),
    // backgroundColor: "rgb(246, 246, 246)",
    // padding: theme.spacing(2, 2.5, 0, 2.5),
  },
  licenceLabel: {
    fontSize: 20,
    fontWeight: 500,
    // marginBottom: theme.spacing(1),
  },
  viewAllLabel: {
    fontSize: 12,
    fontWeight: 300,
    color: 'rgb(255, 212, 40)',
    cursor: 'pointer',
    alignSelf: 'center'
  },
  tag: {
    height: theme.spacing(2),
    fontSize: 10,
    margin: theme.spacing(1, 0.5, 0, 0),
    padding: theme.spacing(0.125, 1, 0, 1),
    backgroundColor: "rgb(255, 211, 40)",
    borderRadius: '10px',
    color: "rgb(255, 255, 255)",
  },

  expiryTag: {
    height: theme.spacing(2),
    fontSize: 10,
    margin: theme.spacing(1, 0.5, 0, 0),
    padding: theme.spacing(0.125, 1, 0, 1),
    backgroundColor: "rgb(255, 220, 205)",
    borderRadius: '10px',
    color: "rgb(209, 1, 1) !important",
  },

  addLicense: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  addLicenceLabel: {
    fontSize: 15,
    color: 'rgb(0, 0, 0)',
    fontWeight: 300,
  },
  licenceDetailsWrapper: {
    display: "flex",
    // margin: theme.spacing(1, 0),
    justifyContent: 'space-between',
  },
  licenceNumber: {
    marginTop: '16px',
    marginRight: '32px',
  },
  licenceExpiry: {
    // padding: theme.spacing(1.5, 1, 1.5, 1),
    display: 'flex',
    // flexWrap: 'wrap'
    flexDirection: 'column',
    justifyContent: 'space-between',
    // alignItems: 'flex-start'

  },
  licenseNoBlock: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'unset',
  },
  licenceHead: {
    fontSize: 14,
    color: 'rgb(153, 164, 184)',
    fontWeight: 500,
    width: '100%'
  },
  licenceNumberText: {
    fontSize: 14,
    color: 'rgb(0, 0, 0)',
    fontWeight: 500,
    marginTop: '4px',
    width: '100%'
  },
  licenceContent: {
    fontSize: 14,
    color: 'rgb(0, 0, 0)',
    fontWeight: 500,
    marginTop: '4px',
    // marginTop: '28px',
  },

}));
